import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { ApiConstant, KeyConstant, LangConstant, SystemConstant } from "const";
import { ApiUtils, HumpUtils, StorageUtils, SystemUtils } from "utils";
import useInvalidateQueries from "hooks/common/useInvalidateQueries";
import qs from "qs";

export default function useUpdateConference() {
  const { t: getLabel } = useTranslation();
  const conferenceError = getLabel(LangConstant.OBJ_CONFERENCE_ERROR, { returnObjects: true });

  const { invalidateServiceQueries } = useInvalidateQueries();

  const updateConferenceMutation = useMutation({
    mutationFn: async data => {
      const payload = {
        conferenceId: data.conferenceId,
        title: data.title,
        description: data.description,
      };
      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.UPDATE_CONFERENCE,
        qs.stringify(HumpUtils.decamelizeKeys(payload)),
      );
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onClose }) => {
      if (response.status === ApiConstant.STT_OK) {
        await invalidateServiceQueries();
        await ApiUtils.apiCreateUserActivitiesLog(SystemConstant.LOGGER_ACTION_TYPES.EDIT_CONFERENCE);
        SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_CONFERENCE_SUCCESS), "success");
        onClose();
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.CONFERENCE_ERROR.MISSING_PARAMETERS
      ) {
        SystemUtils.appendNotification(
          getLabel(conferenceError[SystemConstant.CONFERENCE_ERROR.MISSING_PARAMETERS]),
          "error",
        );
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.CONFERENCE_ERROR.IN_WRONG_FORMAT
      ) {
        SystemUtils.appendNotification(getLabel(conferenceError[SystemConstant.CONFERENCE_ERROR.IN_WRONG_FORMAT]), "error");
      } else if (
        response.status === ApiConstant.STT_BAD_REQUEST &&
        parseInt(response.error) === SystemConstant.CONFERENCE_ERROR.DUPLICATED
      ) {
        SystemUtils.appendNotification(getLabel(conferenceError[SystemConstant.CONFERENCE_ERROR.DUPLICATED]), "error");
      } else {
        SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const updateConference = payload => {
    updateConferenceMutation.mutate(payload);
  };

  return { updateConference };
}
